import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, tap, map } from 'rxjs';
import { Navigation, NavigableWidgetConfigItem } from 'app/core/navigation/navigation.types';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { UrlBuilderService } from '@common/services/url-builder.service';

@Injectable({
  providedIn: 'root'
})
export class NavProviderService {

  /**
   * Constructor
   */
  constructor() {
  }

  get(): Observable<Navigation> {
    return undefined;
  }




}
